var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 416,
    viewBox: "0 0 416 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_217)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272 64C272 93.8214 251.603 118.878 224 125.984V256C224 264.837 216.837 272 208 272C199.163 272 192 264.837 192 256V125.984C164.397 118.878 144 93.8214 144 64C144 28.6538 172.654 0 208 0C243.346 0 272 28.6538 272 64ZM208 32C190.326 32 176 46.3269 176 64C176 81.6731 190.326 96 208 96C225.674 96 240 81.6731 240 64C240 46.3269 225.674 32 208 32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 340.912V182.005C166.477 182.003 172.573 178.04 174.981 171.618C178.083 163.344 173.891 154.122 165.618 151.019L149.696 145.048C149.227 144.869 148.75 144.714 148.269 144.579C145.499 143.813 142.547 143.8 139.731 144.579C139.25 144.714 138.773 144.869 138.304 145.048L10.3821 193.019C4.13712 195.36 0 201.331 0 208V400C0 405.248 2.57328 410.162 6.88656 413.15C11.1997 416.139 16.7045 416.824 21.6179 414.981L144 369.088L266.299 414.95L266.659 415.083C269.693 416.157 273.005 416.298 276.152 415.453C276.675 415.312 277.192 415.144 277.701 414.95L405.618 366.981C411.862 364.64 416 358.67 416 352V160C416 154.752 413.427 149.838 409.114 146.85C404.8 143.861 399.296 143.176 394.382 145.019L272 190.912L261.618 187.019C253.344 183.917 244.122 188.109 241.019 196.382C237.917 204.656 242.109 213.878 250.382 216.981L256 219.088V376.912L160 340.912ZM128 183.088V340.912L32 376.912V219.088L128 183.088ZM384 340.912L288 376.912V219.088L384 183.088V340.912Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 416,
    height: 416,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.e767538cec7b8ce34be5f394f8faef6c.svg";
export { ForwardRef as ReactComponent };